import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PhoneIcon, MenuIcon, XIcon, ShieldCheckIcon } from 'lucide-react';
import { SITE } from '../constants/site';
const NAV = [{
  label: 'Services',
  href: '#services'
}, {
  label: 'Why Us',
  href: '#why'
}, {
  label: 'Service Area',
  href: '#area'
}, {
  label: 'Reviews',
  href: '#reviews'
}, {
  label: 'FAQ',
  href: '#faq'
}];
import { AlertCircleIcon } from 'lucide-react';
export function Header({
  onOpenSchedule
}: {
  onOpenSchedule?: () => void;
}) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-50 w-full transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur shadow-md' : 'bg-white/80 backdrop-blur'}`} data-id="element-145" data-mp="3b81wy3didk79">
      <div className="bg-slate-900 px-4 py-2 text-center text-xs font-bold tracking-wide text-white sm:text-sm" data-id="element-146" data-mp="2wlm91fajw6kf">
        <span className="inline-flex items-center gap-2" data-id="element-147" data-mp="2rk6p5qk4063m">
          <span className="relative flex h-2 w-2" data-id="element-148" data-mp="2mm55b3ev02r3">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-nfgreen opacity-75" data-id="element-149" data-mp="2mmwyk7kzhoe7"></span>
            <span className="relative inline-flex h-2 w-2 rounded-full bg-nfgreen" data-id="element-150" data-mp="3fbcecwbxwaql"></span>
          </span>
          24/7 Emergency Service & Same-Day Appointments Available
        </span>
      </div>
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8" data-id="element-151" data-mp="3aelppkm2k6tk">
        <a href="#top" className="flex items-center gap-3" aria-label={SITE.shortName} data-id="element-152" data-mp="30mfxqavthped">
          <img src={SITE.logoUrl} alt={`${SITE.shortName} logo`} className="h-12 w-auto sm:h-14" data-id="element-153" data-mp="30klldkym35lw" />
        </a>

        <nav className="hidden items-center gap-8 lg:flex" aria-label="Primary" data-id="element-154" data-mp="3tb3p8o75tb0d">
          {NAV.map(item => <a key={item.href} href={item.href} className="text-sm font-semibold text-slate-700 transition-colors hover:text-nfblue" data-id="element-155" data-mp="1rdl109bop3vt">
              {item.label}
            </a>)}
        </nav>

        <div className="hidden items-center gap-3 lg:flex" data-id="element-156" data-mp="1weh4ils4io0p">
          <span className="flex items-center gap-1.5 text-xs font-semibold text-nfgreen-dark" data-id="element-157" data-mp="1hmypaq738xie">
            <ShieldCheckIcon className="h-4 w-4" data-id="element-158" data-mp="1mljruw9tbta0" />
            Licensed & Insured
          </span>
          <button onClick={onOpenSchedule} className="inline-flex items-center gap-2 rounded-full bg-nfblue px-5 py-2.5 text-sm font-bold text-white shadow-sm transition-transform hover:scale-[1.03] hover:bg-nfblue-dark" data-id="element-159" data-mp="18maf66ktfhas">
            Schedule Visit
          </button>
        </div>

        <button className="inline-flex h-10 w-10 items-center justify-center rounded-lg text-slate-700 lg:hidden" onClick={() => setOpen(v => !v)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} data-id="element-160" data-mp="13n7ain8qzd3c">
          {open ? <XIcon className="h-6 w-6" data-id="element-161" data-mp="2y1hy6sdlw17j" /> : <MenuIcon className="h-6 w-6" data-id="element-162" data-mp="2xznlu2gehhf2" />}
        </button>
      </div>

      <AnimatePresence data-id="element-163" data-mp="mf6duz64li9p">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="overflow-hidden border-t border-slate-100 bg-white lg:hidden" data-id="element-164" data-mp="hflcki3hgxtt">
            <nav className="flex flex-col px-4 py-4" aria-label="Mobile" data-id="element-165" data-mp="154mnqd3pan2s">
              {NAV.map(item => <a key={item.href} href={item.href} onClick={() => setOpen(false)} className="rounded-lg px-3 py-3 text-base font-semibold text-slate-700 hover:bg-slate-50" data-id="element-166" data-mp="106bcpz1o66iz">
                  {item.label}
                </a>)}
              <button onClick={() => {
            setOpen(false);
            onOpenSchedule?.();
          }} className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-nfblue px-5 py-3 text-base font-bold text-white" data-id="element-167" data-mp="1a5ad6uca6vuw">
                Schedule Visit
              </button>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}